"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.lender = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
var address_1 = require("./address");
var authorized_officer_1 = require("./authorized-officer");
var claim_payee_1 = require("./claim-payee");
exports.lender = joi_1.default.object({
    address: address_1.address,
    approvedLenderCode: joi_1.default.string()
        .min(0)
        .max(5)
        .optional(),
    approvedLenderName: joi_1.default.string()
        .min(0)
        .max(35)
        .optional(),
    authorizedOfficer: joi_1.default.array()
        .items(authorized_officer_1.authorizedOfficer)
        .max(2),
    claimPayee: claim_payee_1.claimPayee,
    correspondenceLanguage: (_a = joi_1.default.number()
        .integer()).valid.apply(_a, Object.values(constants_1.Language)),
});
exports.default = { lender: exports.lender };
